const EventEmitter = require('eventemitter3');

const BattleCalc = require('../../BattleCalc');
const ScaredCondition = require('../../conditions/ScaredCondition');
const CCHandler = require('../../CCHandler');
const { logError } = require('../../logger');

const DevilMask = function (battleState) {
  this.handle = 'devil_mask';
  this.magic = true;
  this.harm = true;

  this.eventEmitter = new EventEmitter();

  this.isLegal = () => true;

  this.execute = function (actor, victim) {
    if (!actor || !actor.inPlay) {
      return { success: false };
    }

    try {
      const ability = BattleCalc.getEquippedAbility(actor, this.handle);
      const victims = getVictims();
      const result = { scaredConditions: [] };

      for (var i = 0; i < victims.length; ++i) {
        var victim = victims[i];

        if (BattleCalc.rollForReflectMagic(victim)) {
          result.is_reflection = true;
          effects(victim, actor);
        } else {
          effects(actor, victim);
        }
      }

      function effects(instigator, owner) {
        if (!CCHandler.checkForResistFear(owner, battleState)) {
          var scared = new ScaredCondition(
            instigator,
            owner,
            battleState,
            ability.duration
          );
          battleState.onUnitCondition(scared);
          result.scaredConditions.push(scared);
        }
      }

      function getVictims() {
        var victims = [];
        var enemies = battleState.getEnemiesOfUnit(actor);

        for (var i = 0; i < enemies.length; ++i) {
          var enemy = enemies[i];
          if (
            enemy.inPlay &&
            BattleCalc.boardDistance(actor, enemy) <= ability.effectRange
          ) {
            victims.push(enemy);
          }
        }

        return victims;
      }

      result.abilityHandle = this.handle;
      result.actorId = actor.uid;
      result.victimId = victim ? victim.uid : null;
      result.allPieces = battleState.allPieces;
      this.eventEmitter.emit('result', result);
    } catch (err) {
      logError(err, {
        module: 'DevilMask',
        func: 'execute',
        actor,
        victim,
      });

      return { success: false };
    }
  };
};
module.exports = DevilMask;
